export const GAME_SLUGS = Object.freeze({
  GLITCH: 'two-truths-one-glitch',
  PITCH: 'pitch-please',
  HEIST: 'brain-heist',
  ALIBI: 'alibi-club',
  DRAWBACK: 'drawback',
  DEAD_AIR: 'dead-air',
  NO_OFFENSE: 'no-offense',
  SECRET_MENU: 'secret-menu',
  BAD_ADVICE: 'bad-advice',
  UNSENT: 'unsent',
  OPEN_TABS: 'open-tabs',
  SIDE_QUEST: 'side-quest',
  PROVENANCE: 'provenance',
  SAY_MORE: 'say-more',
  RECEIPTS: 'receipts',
})

const gameBase = (slug) => `/games/${slug}`

export const routes = Object.freeze({
  pack: '/',
  imprint: '/impressum',
  privacy: '/datenschutz',
  packJoin: '/join',
  game: gameBase(GAME_SLUGS.GLITCH),
  join: `${gameBase(GAME_SLUGS.GLITCH)}/join`,
  host: (code) => `${gameBase(GAME_SLUGS.GLITCH)}/host/${code}`,
  player: (code) => `${gameBase(GAME_SLUGS.GLITCH)}/play/${code}`,
  pitchGame: gameBase(GAME_SLUGS.PITCH),
  pitchJoin: `${gameBase(GAME_SLUGS.PITCH)}/join`,
  pitchHost: (code) => `${gameBase(GAME_SLUGS.PITCH)}/host/${code}`,
  pitchPlayer: (code) => `${gameBase(GAME_SLUGS.PITCH)}/play/${code}`,
  heistGame: gameBase(GAME_SLUGS.HEIST),
  heistJoin: `${gameBase(GAME_SLUGS.HEIST)}/join`,
  heistHost: (code) => `${gameBase(GAME_SLUGS.HEIST)}/host/${code}`,
  heistPlayer: (code) => `${gameBase(GAME_SLUGS.HEIST)}/play/${code}`,
  alibiGame: gameBase(GAME_SLUGS.ALIBI),
  alibiJoin: `${gameBase(GAME_SLUGS.ALIBI)}/join`,
  alibiHost: (code) => `${gameBase(GAME_SLUGS.ALIBI)}/host/${code}`,
  alibiPlayer: (code) => `${gameBase(GAME_SLUGS.ALIBI)}/play/${code}`,
  drawbackGame: gameBase(GAME_SLUGS.DRAWBACK),
  drawbackJoin: `${gameBase(GAME_SLUGS.DRAWBACK)}/join`,
  drawbackHost: (code) => `${gameBase(GAME_SLUGS.DRAWBACK)}/host/${code}`,
  drawbackPlayer: (code) => `${gameBase(GAME_SLUGS.DRAWBACK)}/play/${code}`,
  deadAirGame: gameBase(GAME_SLUGS.DEAD_AIR),
  deadAirJoin: `${gameBase(GAME_SLUGS.DEAD_AIR)}/join`,
  deadAirHost: (code) => `${gameBase(GAME_SLUGS.DEAD_AIR)}/host/${code}`,
  deadAirPlayer: (code) => `${gameBase(GAME_SLUGS.DEAD_AIR)}/play/${code}`,
  noOffenseGame: gameBase(GAME_SLUGS.NO_OFFENSE),
  noOffenseJoin: `${gameBase(GAME_SLUGS.NO_OFFENSE)}/join`,
  noOffenseHost: (code) => `${gameBase(GAME_SLUGS.NO_OFFENSE)}/host/${code}`,
  noOffensePlayer: (code) => `${gameBase(GAME_SLUGS.NO_OFFENSE)}/play/${code}`,
  secretMenuGame: gameBase(GAME_SLUGS.SECRET_MENU),
  secretMenuJoin: `${gameBase(GAME_SLUGS.SECRET_MENU)}/join`,
  secretMenuHost: (code) => `${gameBase(GAME_SLUGS.SECRET_MENU)}/host/${code}`,
  secretMenuPlayer: (code) => `${gameBase(GAME_SLUGS.SECRET_MENU)}/play/${code}`,
  badAdviceGame: gameBase(GAME_SLUGS.BAD_ADVICE),
  badAdviceJoin: `${gameBase(GAME_SLUGS.BAD_ADVICE)}/join`,
  badAdviceHost: (code) => `${gameBase(GAME_SLUGS.BAD_ADVICE)}/host/${code}`,
  badAdvicePlayer: (code) => `${gameBase(GAME_SLUGS.BAD_ADVICE)}/play/${code}`,
  unsentGame: gameBase(GAME_SLUGS.UNSENT),
  unsentJoin: `${gameBase(GAME_SLUGS.UNSENT)}/join`,
  unsentHost: (code) => `${gameBase(GAME_SLUGS.UNSENT)}/host/${code}`,
  unsentPlayer: (code) => `${gameBase(GAME_SLUGS.UNSENT)}/play/${code}`,
  openTabsGame: gameBase(GAME_SLUGS.OPEN_TABS),
  openTabsJoin: `${gameBase(GAME_SLUGS.OPEN_TABS)}/join`,
  openTabsHost: (code) => `${gameBase(GAME_SLUGS.OPEN_TABS)}/host/${code}`,
  openTabsPlayer: (code) => `${gameBase(GAME_SLUGS.OPEN_TABS)}/play/${code}`,
  sideQuestGame: gameBase(GAME_SLUGS.SIDE_QUEST),
  sideQuestJoin: `${gameBase(GAME_SLUGS.SIDE_QUEST)}/join`,
  sideQuestHost: (code) => `${gameBase(GAME_SLUGS.SIDE_QUEST)}/host/${code}`,
  sideQuestPlayer: (code) => `${gameBase(GAME_SLUGS.SIDE_QUEST)}/play/${code}`,
  provenanceGame: gameBase(GAME_SLUGS.PROVENANCE),
  provenanceJoin: `${gameBase(GAME_SLUGS.PROVENANCE)}/join`,
  provenanceHost: (code) => `${gameBase(GAME_SLUGS.PROVENANCE)}/host/${code}`,
  provenancePlayer: (code) => `${gameBase(GAME_SLUGS.PROVENANCE)}/play/${code}`,
  sayMoreGame: gameBase(GAME_SLUGS.SAY_MORE),
  sayMoreJoin: `${gameBase(GAME_SLUGS.SAY_MORE)}/join`,
  sayMoreHost: (code) => `${gameBase(GAME_SLUGS.SAY_MORE)}/host/${code}`,
  sayMorePlayer: (code) => `${gameBase(GAME_SLUGS.SAY_MORE)}/play/${code}`,
  receiptsGame: gameBase(GAME_SLUGS.RECEIPTS),
  receiptsJoin: `${gameBase(GAME_SLUGS.RECEIPTS)}/join`,
  receiptsHost: (code) => `${gameBase(GAME_SLUGS.RECEIPTS)}/host/${code}`,
  receiptsPlayer: (code) => `${gameBase(GAME_SLUGS.RECEIPTS)}/play/${code}`,
})

export function playerRouteForGame(gameId, code) {
  if (gameId === 'receipts') return routes.receiptsPlayer(code)
  if (gameId === 'say-more') return routes.sayMorePlayer(code)
  if (gameId === 'provenance') return routes.provenancePlayer(code)
  if (gameId === 'side-quest') return routes.sideQuestPlayer(code)
  if (gameId === 'open-tabs') return routes.openTabsPlayer(code)
  if (gameId === 'unsent') return routes.unsentPlayer(code)
  if (gameId === 'bad-advice') return routes.badAdvicePlayer(code)
  if (gameId === 'secret-menu') return routes.secretMenuPlayer(code)
  if (gameId === 'no-offense') return routes.noOffensePlayer(code)
  if (gameId === 'dead-air') return routes.deadAirPlayer(code)
  if (gameId === 'drawback') return routes.drawbackPlayer(code)
  if (gameId === 'alibi-club') return routes.alibiPlayer(code)
  if (gameId === 'brain-heist') return routes.heistPlayer(code)
  if (gameId === 'pitch-please') return routes.pitchPlayer(code)
  return routes.player(code)
}

function matchGameRoute(path, slug, names) {
  const base = gameBase(slug)
  const hostMatch = path.match(new RegExp(`^${base}/host/([A-Za-z]{4})$`))
  const playerMatch = path.match(new RegExp(`^${base}/play/([A-Za-z]{4})$`))
  if (path === base) return { name: names.game }
  if (path === `${base}/join`) return { name: names.join }
  if (hostMatch) return { name: names.host, code: hostMatch[1].toUpperCase() }
  if (playerMatch) return { name: names.player, code: playerMatch[1].toUpperCase() }
  return null
}

export function matchRoute(pathname) {
  const path = pathname.replace(/\/+$/, '') || '/'
  if (path === routes.pack) return { name: 'pack' }
  if (path === routes.imprint) return { name: 'imprint' }
  if (path === routes.privacy) return { name: 'privacy' }
  if (path === routes.packJoin) return { name: 'pack-join' }

  const glitchRoute = matchGameRoute(path, GAME_SLUGS.GLITCH, {
    game: 'game', join: 'join', host: 'host', player: 'player',
  })
  if (glitchRoute) return glitchRoute

  const pitchRoute = matchGameRoute(path, GAME_SLUGS.PITCH, {
    game: 'pitch-game', join: 'pitch-join', host: 'pitch-host', player: 'pitch-player',
  })
  if (pitchRoute) return pitchRoute

  const heistRoute = matchGameRoute(path, GAME_SLUGS.HEIST, {
    game: 'heist-game', join: 'heist-join', host: 'heist-host', player: 'heist-player',
  })
  if (heistRoute) return heistRoute

  const alibiRoute = matchGameRoute(path, GAME_SLUGS.ALIBI, {
    game: 'alibi-game', join: 'alibi-join', host: 'alibi-host', player: 'alibi-player',
  })
  if (alibiRoute) return alibiRoute

  const drawbackRoute = matchGameRoute(path, GAME_SLUGS.DRAWBACK, {
    game: 'drawback-game', join: 'drawback-join', host: 'drawback-host', player: 'drawback-player',
  })
  if (drawbackRoute) return drawbackRoute

  const deadAirRoute = matchGameRoute(path, GAME_SLUGS.DEAD_AIR, {
    game: 'dead-air-game', join: 'dead-air-join', host: 'dead-air-host', player: 'dead-air-player',
  })
  if (deadAirRoute) return deadAirRoute

  const noOffenseRoute = matchGameRoute(path, GAME_SLUGS.NO_OFFENSE, {
    game: 'no-offense-game', join: 'no-offense-join', host: 'no-offense-host', player: 'no-offense-player',
  })
  if (noOffenseRoute) return noOffenseRoute

  const secretMenuRoute = matchGameRoute(path, GAME_SLUGS.SECRET_MENU, {
    game: 'secret-menu-game', join: 'secret-menu-join', host: 'secret-menu-host', player: 'secret-menu-player',
  })
  if (secretMenuRoute) return secretMenuRoute

  const badAdviceRoute = matchGameRoute(path, GAME_SLUGS.BAD_ADVICE, {
    game: 'bad-advice-game', join: 'bad-advice-join', host: 'bad-advice-host', player: 'bad-advice-player',
  })
  if (badAdviceRoute) return badAdviceRoute

  const unsentRoute = matchGameRoute(path, GAME_SLUGS.UNSENT, {
    game: 'unsent-game', join: 'unsent-join', host: 'unsent-host', player: 'unsent-player',
  })
  if (unsentRoute) return unsentRoute

  const openTabsRoute = matchGameRoute(path, GAME_SLUGS.OPEN_TABS, {
    game: 'open-tabs-game', join: 'open-tabs-join', host: 'open-tabs-host', player: 'open-tabs-player',
  })
  if (openTabsRoute) return openTabsRoute

  const sideQuestRoute = matchGameRoute(path, GAME_SLUGS.SIDE_QUEST, {
    game: 'side-quest-game', join: 'side-quest-join', host: 'side-quest-host', player: 'side-quest-player',
  })
  if (sideQuestRoute) return sideQuestRoute

  const provenanceRoute = matchGameRoute(path, GAME_SLUGS.PROVENANCE, {
    game: 'provenance-game', join: 'provenance-join', host: 'provenance-host', player: 'provenance-player',
  })
  if (provenanceRoute) return provenanceRoute

  const sayMoreRoute = matchGameRoute(path, GAME_SLUGS.SAY_MORE, {
    game: 'say-more-game', join: 'say-more-join', host: 'say-more-host', player: 'say-more-player',
  })
  if (sayMoreRoute) return sayMoreRoute

  const receiptsRoute = matchGameRoute(path, GAME_SLUGS.RECEIPTS, {
    game: 'receipts-game', join: 'receipts-join', host: 'receipts-host', player: 'receipts-player',
  })
  if (receiptsRoute) return receiptsRoute

  const legacyHost = path.match(/^\/host\/([A-Za-z]{4})$/)
  const legacyPlayer = path.match(/^\/play\/([A-Za-z]{4})$/)
  if (legacyHost) {
    const code = legacyHost[1].toUpperCase()
    return { name: 'host', code, canonicalPath: routes.host(code) }
  }
  if (legacyPlayer) {
    const code = legacyPlayer[1].toUpperCase()
    return { name: 'player', code, canonicalPath: routes.player(code) }
  }

  return { name: 'not-found' }
}
